import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/video.tsx
var Video = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M3.19995 7C3.19995 5.89543 4.09538 5 5.19995 5H13.2C14.3045 5 15.2 5.89543 15.2 7V17C15.2 18.1046 14.3045 19 13.2 19H5.19995C4.09538 19 3.19995 18.1046 3.19995 17V7Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("path", {
		d: "M15.7527 9.72361L19.7527 7.72361C20.4176 7.39116 21.2 7.87465 21.2 8.61803V15.382C21.2 16.1253 20.4176 16.6088 19.7527 16.2764L15.7527 14.2764C15.414 14.107 15.2 13.7607 15.2 13.382V10.618C15.2 10.2393 15.414 9.893 15.7527 9.72361Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	})] }) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.34998 7C2.34998 5.48122 3.58119 4.25 5.09998 4.25H13.1C14.6188 4.25 15.85 5.48122 15.85 7V8.78647L19.3174 7.05279C20.4809 6.471 21.85 7.31712 21.85 8.61803V15.382C21.85 16.6829 20.4809 17.529 19.3174 16.9472L15.85 15.2135V17C15.85 18.5188 14.6188 19.75 13.1 19.75H5.09998C3.58119 19.75 2.34998 18.5188 2.34998 17V7Z",
		fill: "currentColor"
	})
});
//#endregion
export { Video };
